import React, { ReactNode, useEffect, useState } from "react";

import { bemClassNames, useInView } from "@multiweb/reactUtils";

export type ResponsiveListItemProps<T> = {
    /** Data pro vykreslení položky. */
    item: T;
    /** Funkce pro vykreslení položky. */
    itemRenderer: (item: T) => ReactNode;
    /** Určuje, zda je item první. Pokud ano, zobrazí se i pokud se do LLF nevleze celý. Defaultní hodnota je `false`.  */
    isFirst?: boolean;
    /** Komponenta, vůči které se vyhodnocuje, zda je Item zobrazen. @see IntersectionObserver */
    root?: HTMLElement | null;
    /** Callback, který se volá při prvním zobrazení itemu. */
    onShownCallback?: () => void;
};

const classNames = bemClassNames("responsive-list-item");

export const ResponsiveListItem = <T,>({
    item,
    itemRenderer,
    isFirst = false,
    root,
    onShownCallback,
}: ResponsiveListItemProps<T>) => {
    const [onShownCallbackCalled, setOnShownCallbackCalled] = useState<boolean>(!onShownCallback); // true, pokud handled nepředáme.
    const [ref, inView] = useInView({ threshold: isFirst ? 0 : 1, root });
    useEffect(() => {
        if (inView && !onShownCallbackCalled) {
            onShownCallback && onShownCallback();
            setOnShownCallbackCalled(true);
        }
    }, [inView, onShownCallback, onShownCallbackCalled]);

    return (
        <div className={classNames({ hidden: !inView })} ref={ref}>
            {itemRenderer(item)}
        </div>
    );
};
